// Shared lookup tables used by both the authenticated dashboard (App.js)
// and the public programmatic pages (PublicListings.js).

// Lead professions/categories.
// Keys must match entities.profession values set by the resolver. Only list
// categories that actually have data — a filter with zero rows reads as a bug.
export const PROFESSIONS = [
  { key: '', label: 'All categories' },
  { key: 'food', label: 'Restaurants & Food Service' },
  { key: 'bar', label: 'Bars & Liquor Licenses' },
  { key: 'lodging', label: 'Hotels & Lodging' },
  { key: 'construction', label: 'General Contractors' },
  { key: 'hvac', label: 'HVAC' },
  { key: 'roofing', label: 'Roofing' },
  { key: 'plumbing', label: 'Plumbing' },
  { key: 'electrical', label: 'Electrical' },
  { key: 'pool', label: 'Pool & Spa' },
  { key: 'hoa', label: 'HOA & Property Management' },
  { key: 'corporate', label: 'Corporations (Sunbiz)' },
];

// Lead-stage badge shown next to the business name. plan_review is the
// earliest signal (facility hasn't opened); inbound is a hand-raiser who
// submitted or claimed their own listing — the highest-value stage.
export const SIGNAL_BADGES = {
  inbound: { label: 'Inbound', fg: '#FDF2F8', bg: '#9D174D' },
  plan_review: { label: 'Pre-opening', fg: '#78350F', bg: '#FCD34D' },
  ownership_change: { label: 'New owner', fg: '#F0FDF4', bg: '#166534' },
  new_license: { label: 'New license', fg: '#EFF6FF', bg: '#1E40AF' },
};

// All 67 Florida counties, for the geographic filter dropdown.
export const FL_COUNTIES = [
  'Alachua', 'Baker', 'Bay', 'Bradford', 'Brevard', 'Broward', 'Calhoun',
  'Charlotte', 'Citrus', 'Clay', 'Collier', 'Columbia', 'Dade', 'DeSoto',
  'Dixie', 'Duval', 'Escambia', 'Flagler', 'Franklin', 'Gadsden', 'Gilchrist',
  'Glades', 'Gulf', 'Hamilton', 'Hardee', 'Hendry', 'Hernando', 'Highlands',
  'Hillsborough', 'Holmes', 'Indian River', 'Jackson', 'Jefferson',
  'Lafayette', 'Lake', 'Lee', 'Leon', 'Levy', 'Liberty', 'Madison', 'Manatee',
  'Marion', 'Martin', 'Monroe', 'Nassau', 'Okaloosa', 'Okeechobee', 'Orange',
  'Osceola', 'Palm Beach', 'Pasco', 'Pinellas', 'Polk', 'Putnam', 'Santa Rosa',
  'Sarasota', 'Seminole', 'St. Johns', 'St. Lucie', 'Sumter', 'Suwannee',
  'Taylor', 'Union', 'Volusia', 'Wakulla', 'Walton', 'Washington',
];
